import { Component, Inject } from '@angular/core';
import {
  L10N_CONFIG,
  L10N_LOCALE,
  L10nConfig,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { AuthService } from '../shared/auth.service';
import { BreadcrumbService } from '../shared/breadcrumb/breadcrumb.service';
import { Kernantwort } from '../shared/response/kernantwort.model';
import { SessionService } from '../shared/session.service';
import { Datei } from './datei/datei.model';
import { Kategorie } from './kategorie/kategorie.model';

import { HttpClient } from "@angular/common/http";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APIConfigService } from "../api.config.service";
import { LoggerService } from '../shared/logger.service';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { AngularMaterial2Module } from "../app.module.material";
import { Data } from "../providers/data";
import { ErrorHelper } from "../shared/error.helper";

const PATH_FILE = 'app/protected/protected.component.ts';
const OBJ_LNG_NAME = 'kategorie';
const BACKEND_PATH_PREFIX = 'kategorie/';

@Component({
  templateUrl: './protected.component.html',
  standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, RouterLink]

})
export class ProtectedComponent {
  pathFile = PATH_FILE;
  // jwtHelper: JwtHelper = new JwtHelper();
  data: Kategorie[] = Array<Kategorie>();
  kategorieTyp: number;
  kategorieId: string;
  kategorieName: string;
  ladedaten: boolean = true;
  ladedatenKategorien: boolean = true;
  maxSortierung: number = 1;
  fehlerMain: Kernantwort = null;
  dialogrunningajaxcall: boolean = false;
  // @ViewChild(Md2DataTable) md2datatable: Md2DataTable;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public authService: AuthService,
    public apiConfigService: APIConfigService,
    public http: HttpClient,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService,
    public sessService: SessionService,
    public title: Title,
    private aktuelleKategorie: Data,
    private _logger: LoggerService,
    public media: MediaObserver
  ) {
    // Set document title.
    this.title.setTitle(this.getTitle());
    this.breadcrumbService.addFriendlyNameForRoute('/vertraege', this.translation.translate('menue.vertraege.#'));
    this.breadcrumbService.addFriendlyNameForRoute('/dokumente', this.translation.translate('menue.dokumente.#'));

    this.kategorieTyp = this.router.url.indexOf("home") !== -1 ? 0 :
      (this.router.url.indexOf("dokumente") !== -1 ? 1 :
        (this.router.url.indexOf("vertraege") !== -1 ? 2 : 0));

    this.kategorieId = this.router.url.indexOf("home") !== -1 ? "home" :
      (this.router.url.indexOf("dokumente") !== -1 ? "dokumente" :
        (this.router.url.indexOf("vertraege") !== -1 ? "vertraege" : "home"));

    switch (this.kategorieTyp) {
      case 0:
        this.kategorieName = this.translation.translate('menue.news.#');
        break;
      case 1:
        this.kategorieName = this.translation.translate('menue.dokumente.#');
        break;
      case 2:
        this.kategorieName = this.translation.translate('menue.vertraege.#');
        break;
    }
    this.breadcrumbService.addFriendlyNameForRoute('/home/' + this.kategorieTyp, this.kategorieName);
    this.getKategorien();
  }

  getTitle() {
    return this.translation.translate('home.willkommen') + ' - ' + this.translation.translate('project.title');
  }

  private getKategorien() {
    this._logger.log(PATH_FILE + ' - getKategorien Begin');

    this.ladedatenKategorien = true;
    this.ladedaten = this.ladedatenKategorien;


    this.http.get<Kategorie[]>(this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX + 'zeige/' + this.kategorieTyp)
      // Um mehrfachaufrufe zu verhindern
      .subscribe({
        next: (data) => {
          this.data = data;
          this._logger.log(PATH_FILE + ' KATEGORIEN FÜR HOME = ', this.data);
          if (this.data.length > 0)
            this.maxSortierung = this.data.length;
          this._logger.log(PATH_FILE + ' - getKategorien End');
          this.ladedatenKategorien = false;
          this.ladedaten = this.ladedatenKategorien;
        },
        error: (err) => {
          this.ladedatenKategorien = false;
          this.ladedaten = this.ladedatenKategorien;
          ErrorHelper.handleError(err, "Fehler beim holen der Kategorien", this._logger, this.translation)
        },
        complete: () => {
          this.ladedatenKategorien = false;
          this.ladedaten = this.ladedatenKategorien;
          this._logger.log(PATH_FILE + ' - Holen der Kategorien abgeschlossen');
        }
      });
  } // getKategorien

  goToEintraege(kategorie: Kategorie) {
    this._logger.log(PATH_FILE + " - goToEintrage: /protected/kategorieeintrag-" + this.kategorieId + "/" + kategorie.id);

    this.aktuelleKategorie.storage = kategorie;
    //4 ist fake Kategorie für Fragebogenanzeige
    if(kategorie.typ!==4) {
      this.breadcrumbService.addFriendlyNameForRoute('/protected/kategorieeintrag-' + this.kategorieId + '/' + kategorie.id, kategorie.bezeichnung);
      this.breadcrumbService.addFriendlyNameForRoute('/protected/kategorieeintrag-' + this.kategorieId, this.kategorieName);
      this.router.navigate(["/protected/kategorieeintrag-" + this.kategorieId + "/" + kategorie.id]);
    }
    else {
      this.breadcrumbService.addFriendlyNameForRoute('/protected/fb', kategorie.bezeichnung);
      this.router.navigate(["/protected/fb"]);
    }
  } // goToEintraege

  getBildVerkleinertUrl(datei: Datei, zusatz: string = ''): string {
    if (datei != null)
      return this.authService.getAuthUrl(datei.url + zusatz);
    return null;
  }

  getStyle(datei: Datei) {
    this._logger.log(PATH_FILE + ' - getStyle')
    // snip snip -> fetch the url from somewhere
    const picUrl = this.getBildVerkleinertUrl(datei, '/w250');
    const style = `background-image: url('${picUrl}')`;
    return style;
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }


  setzeFehler(fehler: Kernantwort) {
    this.fehlerMain = fehler;
  }

  getDateiUrl(url: string): string {
    return this.authService.getAuthUrl(this.apiConfigService.REST_API_BASE() + url);
  }

  onMobile() {
    return this.media.isActive('gt-sm') ? 'none' : '';
  }

  onDesktop() {
    return !this.media.isActive('gt-sm') ? 'none' : '';
  }


}
